import { render } from "./AppRuntimeConfigOverlay.vue?vue&type=template&id=2b7a7d0a&scoped=true&ts=true"
import script from "./AppRuntimeConfigOverlay.vue?vue&type=script&lang=ts"
export * from "./AppRuntimeConfigOverlay.vue?vue&type=script&lang=ts"

import "./AppRuntimeConfigOverlay.vue?vue&type=style&index=0&id=2b7a7d0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7a7d0a"]])

export default __exports__